<template>
	<div class="base-header">
		<ul class="nav">
			<li class="select">CDK兑换</li>
		</ul>
		<div class="content">
			<div class="ment-four">
				<input class="input" placeholder="请输入兑换码" type="text" v-model="cdk" />
				<span class="duihuan" @click="getcdk">兑换</span>
			</div>
		</div>
		<div class="win-box" v-if="winState">
			<mywin :winList="winList" :winState="winState" :isis="true" @winexchange="winexchange($event)"
				@winget="winget($event)" @winX="winX($event)"></mywin>
		</div>
		<div class="win-box" v-if="money">
			<div class="win">
				<div class="win-conm">
					<div class="win-tips">恭喜获得</div>
				</div>
				<div class="win-conm" style="color: white;display: flex;align-items: center;flex-flow: row;">
					<div>{{money}}</div><img src="../../../assets/img/money.png" style="width: 24px;">
				</div>
				<div class="win-span2" @click="winState = false;money = null">放入背包</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Utils from "./../../../assets/js/util.js";
	import CdkChange from "@/views/cdk-change/cdk-change.vue";
	import mywin from "@/components/my_win.vue";
	export default {
		components: {
			CdkChange,
			mywin
		},
		props: ["type"],
		data() {
			return {
				winState: false,
				winList: {},
				loading: false,
				payTitle: "",
				payTitleIcon: "wechat.svg",
				payFooter: "",
				payFooterDesc: "",
				payBox: false,
				cdk: "",
				payType: "wechat",
				list: [],
				payObj: {
					rmb: 0,
					money: 5,
					state: false
				},
				money: null,
				rmb: 0,
				ratioList: [],
				firstGiveValidate: false,
				ordinaryValidate: false,
				firstGive: {}, //新用户活动
				ordinaryActivity: {}, //非新用户充值活动
				is_new: false, //是否是新用户
				userInfo: {},
				payInfoData: {
					flag: false,
					type: "",
					checked2: false,
					checked1: false,
				}, // 充值提示
				// cdk兑换的皮肤
				cdk_skin: {},
			};
		},
		mounted() {
			this.payBox = false;
			this.amountList();
			let userInfo = JSON.parse(localStorage.getItem("userInfo"));
			this.userInfo = userInfo;
			console.log(this.userInfo);
			if (this.$route.query.type) {
				this.payType = this.$route.query.type;
			}
		},
		methods: {
			//子组件修改父组件
			winexchange(msg) {
				this.winState = msg;
			},
			winget(msg) {
				this.winState = msg;
			},
			winX(msg) {
				this.winState = msg;
			},
			//充值送多少
			// getRatio() {
			//   this.$axios.get("index/User/giveAboutRecharge").then((res) => {
			//     let data = res.data;
			//     console.log(data);
			//     if (data.status == 1) {
			//       this.ratioList = data.data;
			//     }
			//   });
			// },
			// 跳转到个人账单
			goToBill() {
				this.$router.push({
					path: `/Bill`,
				});
			},
			// 联系客服
			concact() {
				// http://wpa.qq.com/msgrd?v=3&uin=2484784479&site=qq&menu=yes
				// tencent://message/?uin=1187276773&Site=&Menu=yes
				// window.open("http://wpa.qq.com/msgrd?v=3&uin=1064097081&site=qq&menu=yes");
				window.open(
					"https://qm.qq.com/cgi-bin/qm/qr?k=TFB6vBuBWEJpO1H8VADjLQZP9PpF8OUM&jump_from=webapi&authKey=tUy1AIU9X4U0Ie5WNGGDvFFi7SSs7is4vZ0qeHg8iu6KUWm5nMHMYVwly29zHVFB"
				);
			},
			//input框
			getInput(value) {
				//  /^(0\.0[1-9]|0\.[1-9]\d|[1-9]\d?(\.\d\d)?|[1-4]\d\d(\.\d\d)?|500)$/
				if (value == "") {
					this.list[6].money = "";
					this.list[6].rmb = 0;
				} else {
					this.list[6].money = value;
					this.list[6].rmb = (value * this.rmb).toFixed(2);
				}
				value = Number(value);

				let money = Number(this.ratioList.money);
				let limit = Number(this.ratioList.limit);
				if (money > 0 && limit > 0) {
					if (value >= money && value <= limit) {
						this.setTrue();
					} else {
						this.setFalse();
					}
				} else if (money == 0 && limit == 0) {
					this.setTrue();
				} else if (money > 0 && limit == 0) {
					console.log(value >= money);
					if (value >= money) {
						this.setTrue();
					} else {
						this.setFalse();
					}
				} else if (money == 0 && limit > 0) {
					if (value <= limit) {
						this.setTrue();
					} else {
						this.setFalse();
					}
				} else {
					this.setFalse();
				}
			},
			CDKInput(e) {
				this.CDK = e.detail.value;
			},
			setTrue() {
				this.list[this.list.length - 1].is_first_give = true;
				this.list[this.list.length - 1].billieState = true;
				this.list[this.list.length - 1].billie = this.ratioList.billie;
			},
			setFalse() {
				this.list[this.list.length - 1].is_first_give = false;
				this.list[this.list.length - 1].billieState = false;
				this.list[this.list.length - 1].billie = 0;
			},
			//加
			addInput() {
				if (this.list[6].money < 5) {
					this.list[6].money = 5.0;
					this.list[6].rmb = 5.0 * this.rmb;
				} else {
					this.list[6].money = (Number(this.list[6].money) + 1).toFixed(2);
					this.list[6].rmb = (this.list[6].money * this.rmb).toFixed(2);
				}
				// console.log(11)
				for (let i = 0; i < this.ratioList.length; i++) {
					if (this.list[6].money >= Number(this.ratioList[i].money)) {
						this.list[6].billie = this.ratioList[i].billie;
						this.list[6].billieState = true;
					} else {
						this.list[6].billieState = false;
					}
				}
			},
			//减
			remInput() {
				if (this.list[6].money <= 5) {
					return;
				}
				this.list[6].money = ((this.list[6].money * 100 - 1 * 100) / 100).toFixed(
					2
				);
				this.list[6].rmb = (this.list[6].money * this.rmb).toFixed(2);
				for (let i = 0; i < this.ratioList.length; i++) {
					if (this.list[6].money >= Number(this.ratioList[i].money)) {
						this.list[6].billie = this.ratioList[i].billie;
						this.list[6].billieState = true;
					} else {
						this.list[6].billieState = false;
					}
				}
			},
			amountList() {
				let param = {
					player_id: localStorage.getItem("id"),
				};
				this.$axios
					.post("index/User/giveAboutRecharge", this.$qs.stringify(param))
					.then((res) => {
						let data = res.data;
						this.is_new = data.data.new;
						if (data.status == 1) {
							// this.ratioList = data.data.giveInfo;
							// if(data.data.firstGive){
							//   this.firstGiveValidate = true;
							//   this.firstGive = data.data.firstGive;
							// }
							if (this.is_new) {
								if (data.data.recharge_activity.length > 0) {
									data.data.recharge_activity.forEach((e) => {
										if (e.type == 1) {
											this.firstGiveValidate = true;
											this.ratioList = e;
											this.firstGive = e;
										}
										if (e.type == 2) {
											this.firstGiveValidate = false;
											this.ratioList = e;
											this.ordinaryActivity = e;
										}
									});
								}
							} else {
								this.firstGiveValidate = false;
								if (data.data.recharge_activity.length > 0) {
									data.data.recharge_activity.forEach((e) => {
										if (e.type == 2) {
											this.ratioList = e;
											this.ordinaryActivity = e;
										}
									});
								}
							}
						}
						// 获取充值列表
						this.$axios.get("/index/pay/chargeInfoList").then((res) => {
							let data = res.data;
							if (data.status == 1) {
								this.rmb = data.data.exchange_rate;
								this.payObj.rmb = data.data.exchange_rate * 5;
								let list = res.data.data.list;
								list.push(this.payObj);
								list.forEach(function(item, index) {
									item.state = false;
									if (index == 0) {
										item.state = true;
									}
								});
								this.list = list;
								// console.log(this.list);
								for (let i = 0; i < this.list.length; i++) {
									let money = Number(this.list[i].money); //当前充值列表金额
									let lower_limit = Number(this.ratioList.money); //后台设定下限
									let upper_limit = Number(this.ratioList.limit); //后台设定上限
									// console.log(money,lower_limit,upper_limit);
									if (lower_limit > 0 && upper_limit > 0) {
										if (money >= lower_limit && money <= upper_limit) {
											this.list[i].billie = this.ratioList.billie;
											this.list[i].billieState = true;
										}
									}
									if (lower_limit == 0 && upper_limit == 0) {
										this.list[i].billie = this.ratioList.billie;
										this.list[i].billieState = true;
									}
									if (lower_limit > 0 && upper_limit == 0) {
										if (money >= lower_limit) {
											this.list[i].billie = this.ratioList.billie;
											this.list[i].billieState = true;
										}
									}
									if (lower_limit == 0 && upper_limit > 0) {
										if (money <= upper_limit) {
											this.list[i].billie = this.ratioList.billie;
											this.list[i].billieState = true;
										}
									}
								}
							}
						});
						// console.log(this.ratioList);
						// console.log(this.ordinaryActivity);
						if (!this.empty(this.ordinaryActivity)) {
							this.ordinaryValidate = true;
						}
					});
			},

			//领取红包
			getcdk() {
				if (!this.cdk) {
					this.$message({
						message: "请输入cdk口令",
						type: "warning",
					});
					return;
				}
				// this.hongbaoState1 = false;
				// this.hongbaoState2 = true;
				let param = {
					password: this.cdk,
				};
				this.$axios
					.post("/api/welfare/cdk", this.$qs.stringify(param))
					.then((res) => {
						let data = res.data;
						if (data.code == 1) {
							this.$message({
								message: "CDK成功兑换",
								type: "success",
							});
						} else {
							this.$message({
								message: data.msg,
								type: "warning",
							});
						}
						// 皮肤
						if (data.data.data && data.data.data.id) {
							this.cdk_skin = data.data.data;
							this.winList.skins_info = [];
							this.winList.skins_info[0] = data.data.data;
							this.winList.skins_info[0]['background'] = require('../../../assets/img/bg-jin.png');
							this.openBoxState = false;
							this.winState = true;
						} else if (data.data.data) {
							this.money = data.data.data;
							this.$parent.$parent.getPlayerInfo();
						}
					});
			},

			empty(obj) {
				for (let key in obj) {
					return false; //非空
				}
				return true; //为空
			},
			epayjump() {
				this.$router.push = "https://69csgoskins.com.cn/SDK/index.php";
			},
			payInfo(t) {
				let money = 0;
				for (let i = 0; i < this.list.length; i++) {
					if (this.list[i].state) {
						money = this.list[i].money;
					}
				}
				console.log(Number(money));
				if (this.userInfo.total_amount == "0.00" || money > 199) {
					this.payInfoData.flag = true;
					this.payInfoData.type = t;
				} else {
					this.payAction(t);
				}
			},
			checkPayInfo() {
				if (this.payInfoData.checked1 && this.payInfoData.checked2) {
					if (this.payInfoData.type) {
						this.payInfoData.flag = false;
						this.payAction(this.payInfoData.type);
					}
				} else {
					this.$message.info("请阅读并勾选所有协议");
				}
			},
			payAction(t) {
				if (this.list[6].money < 5 && this.list[6].state == true) {
					this.$message({
						message: "充值Z币不少于5个",
						type: "warning",
					});
					return;
				}

				if (t == "wechat") {
					this.loading = true;
					this.payTitle = "微信支付";
					this.payTitleIcon = "wechat.svg";
					this.payFooter = "请使用微信扫一扫";
					this.payFooterDesc = "扫描二维码完成支付";
					this.pay("weixin");
					return;
				}
				this.loading = true;
				this.payTitle = "支付宝支付";
				this.payTitleIcon = "alipay.svg";
				this.payFooter = "请使用支付宝扫一扫";
				this.payFooterDesc = "扫描二维码完成支付";
				this.pay("zhifubao");
			},
			pay(type) {
				let money = 0;
				for (let i = 0; i < this.list.length; i++) {
					if (this.list[i].state) {
						money = this.list[i].money;
					}
				}

				let _this = this;
				let data = {
					mode: type,
					money: money,
					mobile: this.userInfo.mobile,
				};
				_this.$axios.post("/index/Pay/recharge", data).then((res) => {
					let data = res.data;
					this.loading = false;
					if (data.status == 1) {
						//this.$refs.qrcode.innerHTML = "";
						this.payBox = true;
						this.loading = false;
						this.$nextTick(() => {
							const qrCode = new QRCode("qrcode", {
								width: 160,
								height: 160,
								text: res.data.data,
							});
						});
					} else {
						this.$message({
							message: res.data.msg,
							// message: "微信支付维护中，请使用支付宝充值",
							type: "warning",
						});
					}
				});
			},
			handleClose() {
				this.payBox = false;
				this.$refs.qrcode.innerHTML = "";
			},
			saveImg() {
				var canvasData = this.$refs.qrcode.getElementsByTagName("canvas");
				var a = document.createElement("a");
				var event = new MouseEvent("click");
				a.href = canvasData[0].toDataURL("image/png");
				a.download = "支付二维码";
				a.dispatchEvent(event);
			},
			weixinMoney(index) {
				for (let i = 0; i < this.list.length; i++) {
					this.list[i].state = false;
				}
				this.list[index].state = true;
			},
			zhifuMoney(index) {
				for (let i = 0; i < this.list.length; i++) {
					this.list[i].state = false;
				}
				this.list[index].state = true;
			},
			epayMoney(index) {
				for (let i = 0; i < this.list.length; i++) {
					this.list[i].state = false;
				}
				this.list[index].state = true;
			},
		},
	};
</script>

<style lang="less" scoped>
	//中奖后盒子
	.win-box {
		position: fixed;
		z-index: 99999;
		top: 0;
		left: 0;
		height: 100vh;
		width: 100vw;
		background-color: rgba(0, 0, 0, 0.7);
		display: grid;
		place-items: center;
	}

	.win-conm {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;

		.win-tips {
			height: 60px;
			color: #fff;
			font-size: 16px;
			line-height: 60px;
			font-weight: bold;
		}

		ul {
			margin: -5px;
			width: 100%;
			display: flex;
			flex-flow: row wrap;
			justify-content: center;

			li {
				.win-warp {
					border-radius: 5px;
					overflow: hidden;
					// width: 100%;
					cursor: pointer;
					position: relative;

					.win-text {
						text-overflow: ellipsis;
						position: absolute;
						width: 100%;
						text-align: center;
						left: 0;
						right: 0;
						bottom: 0;
						margin-left: auto;
						margin-right: auto;
						bottom: 30px;
						font-size: 8px !important;
						color: white;
					}

					.win-textt {
						width: 100%;
						padding: 6px 0;
						background-color: #e9b10e;
						background-size: 100% 100%;
						border: 1px solid #ffea95;
						color: #000000;
						// padding: 10px;
						//overflow: hidden;
						//white-space: nowrap;
						text-overflow: ellipsis;
						font-size: 10px;
					}
				}
			}
		}
	}

	.win_container {
		display: grid !important;
		gap: 5px 10px;
		overflow: auto;
		height: 320px;
		overflow-x: hidden;
		grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)) !important;

		li {
			width: 100%;
		}

		.win-warp {
			display: flex;
			width: 100%;
			flex-direction: column;
		}
	}

	.win {

		width: 450px;
		padding: 20px;
		background-color: #1c2230;
		position: relative;
		box-sizing: border-box;
		border-radius: 10px;

		.win-span2 {
			padding: 10px 0;
			height: 20px;
			background-color: #e9b10e;
			background-size: 100% 100%;
			border: 1px solid #ffea95;
			color: #000000;
			display: flex;
			font-weight: bold;
			justify-content: center;
			align-items: center;
			border-radius: 5px;
			margin-top: 15px;
		}

		.win-span2:hover {
			cursor: pointer;
		}
	}

	.base-header {
		font-family: '微软雅黑';

		.nav {
			height: 42px;
			font-size: 18px;
			font-weight: 500;
			display: flex;
			align-items: center;
			justify-content: flex-start;

			li {
				width: 110px;
				height: 48px;
				line-height: 48px;
				color: white;
				margin-right: 40px;
				text-align: center;
				padding: 0 24px;
			}

			.select {
				color: #69e0ff !important;
				border-bottom: 2px solid #69e0ff;
			}

			li:hover {
				background: rgba(255, 255, 255, .1);
			}

			.select:hover {
				background: rgba(105, 224, 255, .1);
			}
		}

		.content {
			width: 100%;
			min-height: 600px;
			background: rgba(71, 201, 243, .14);
			border-radius: 4px;
			padding: 20px 25px;
			margin-top: 32px;
			display: flex;
			align-items: center;
			justify-content: center;

			.ment-four {
				display: flex;
				align-items: center;
				margin-bottom: 200px;

				input {
					width: 390px;
					height: 35px;
					padding-left: .8rem;
					color: #fff;
					outline: none;
					opacity: .9;
					background: rgba(23, 188, 241, .2);
					border-radius: 4px;
					border: 0;
				}

				.duihuan {
					margin-left: 12px;
					width: 74px;
					height: 35px;
					background: linear-gradient(180deg, #47c9f3, #1394bf);
					border-radius: 4px;
					font-size: 15px;
					font-weight: 500;
					color: #fff;
					line-height: 21px;
					display: -webkit-box;
					display: -ms-flexbox;
					display: flex;
					align-items: center;
					justify-content: center;
				}

			}

			.c-top {
				span:first-child {
					font-size: 15px;
					font-weight: 400;
					color: #fff;
					line-height: 21px;
				}

				span:last-child {
					font-size: 11px;
					font-weight: 400;
					color: #adb8ba;
					line-height: 16px;
					margin-left: 5px;
				}
			}

			.c-center {
				margin-top: 24px;
				display: flex;
				flex-wrap: wrap;

				.boxs {
					width: 152px;
					height: 102px;
					background-image: url('../../../assets/img/my/content.png');
					background-repeat: no-repeat;
					background-size: 100% 100%;
					margin-right: 10px;
					margin-bottom: 20px;
					border: 2px solid #142a40;
					font-size: 15px;
					font-weight: 700;
					color: #fff;
					line-height: 21px;
					display: flex;
					align-items: center;
					justify-content: center;

					span {
						margin-left: 6px;
					}
				}

				.select {
					background-image: url('../../../assets/img/my/content1.png');
				}
			}

			.c-bottom {
				color: white;
				font-size: 18px;

				.cb-box {
					display: flex;
					align-items: center;

					.cb-content:first-child {
						margin-left: 0;
					}

					.cb-content {
						margin-left: 32px;

						span {
							display: flex;
							align-items: center;
							margin-left: 0;
						}

						span span:last-child {
							margin-left: 12px;
						}
					}
				}

				.cb-chongzhi {
					margin-top: 32px;
					background: rgb(101, 108, 157);
					width: 120px;
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.cb-content {
					display: flex;
					align-items: center;
					margin-top: 32px;

					span:last-child {
						margin-left: 12px;
					}

					.zhifubao {
						display: flex;
						align-items: center;
						width: 158px;
						height: 44px;
						background: #141b25;
						border-radius: 8px;
						border: 1px solid #adb8ba;
						box-shadow: 0 0 10px 0 rgba(52, 164, 225, 1);
						border: 1px solid rgba(52, 164, 225, 1);
						font-size: 17px;
						font-weight: 500;
						color: #fff;
						line-height: 24px;
						text-shadow: 0 0 2px rgba(71, 201, 243, .55);
						display: -webkit-box;
						display: -ms-flexbox;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 20px;
						}
					}

					.yellow {
						font-size: 24px;
						font-weight: 500;
						color: #fc0;
						line-height: 33px;
					}
				}
			}

			.el-checkbox {
				margin-top: 32px;
			}

			/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
			.el-checkbox__input.is-indeterminate .el-checkbox__inner {
				color: rgb(71, 201, 243);
			}

			/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
				color: rgb(255, 255, 255);
				opacity: 0.8;
			}

			/deep/.el-checkbox__label {
				color: rgb(255, 255, 255);
				opacity: 0.8;

				strong {
					font-weight: 600;
					color: rgb(133, 203, 255);
				}
			}

		}
	}
</style>